import { render, staticRenderFns } from "./trashItems.vue?vue&type=template&id=0cf2ee91"
import script from "./trashItems.vue?vue&type=script&lang=js"
export * from "./trashItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports